<ng-container *ngIf="thumbnailURL; else noImage">
  <button *ngIf="isAvailable && showAttributeValue(attribute,attributeValue)"
          (click)="valueSelected.emit({attribute, attributeValue})"
          mat-button class="attribute-value"
          [class.is-set]="isSet">
    <div class="button-contents">
      <img [class.outline]="isSet" class="thumbnail" [src]="thumbnailURL" alt="material">
      <span *ngIf="!hideName" class="name">{{ attributeValueName }}</span>
    </div>
  </button>
</ng-container>

<ng-template #noImage>
  <button *ngIf="isAvailable"
          style="font-size: 1.3em;"
          [class.outline]="isSet"
          (click)="valueSelected.emit({attribute, attributeValue})"
          mat-button
          [class.is-set]="isSet">
    {{ attributeValueName }}
  </button>
</ng-template>
